// extracted by mini-css-extract-plugin
export default {"container":"Settings_container__Xk0II","settingsList":"Settings_settingsList__R4Zgf","settingsListItem":"Settings_settingsListItem__7qtEH","active":"Settings_active__8rSLF"};